import axiosClient from ".";
class SignUpAPI {
  static userRegistration(data) {
    return axiosClient.post("/users/sign_up", data);
  }
}
export default SignUpAPI;
